import React from 'react'
import ListComponent from '../../components/qna/ListComponent'

const ListPage = () => {
  return (
    <>
      <div className='mb-5'>ListPage  페이지</div>
      <ListComponent />
    </>
  )
}

export default ListPage